module.exports = __webpack_public_path__ + "static/media/avatar.11129905.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/avatar.png
// module id = 186
// module chunks = 0